import React, { useState, useCallback, useContext } from "react";
import { styled } from '@mui/material/styles';

import { getEntityUrl, getTranslatedTopbarEntities } from "../../util";

import { GatsbyImage, getImage, getSrc } from "gatsby-plugin-image"

import { Link, useStaticQuery, graphql } from "gatsby";
import { IconButton, Slide } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

import { useTheme } from "@mui/material/styles";

import { ColorModeContext } from '../../components/Layout';
import LanguageMenu from "../../components/LanguageMenu";
import {DarkmodeSwitch} from "../../components/Switch/DarkmodeSwitch";
import {SettingsContext} from "../../context/SettingsContext";

const MainMenu = (props) => {
    const { allStrapiEntities: entities } = useStaticQuery(staticQuery);
    const { settings } = useContext(SettingsContext);
    const { pageContext, entity, locales } = props;
    const { locale: curLocale, defaultLocale } = pageContext || {};
    const translatedTopbarEntites = getTranslatedTopbarEntities(settings, entities, curLocale);

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
        event.stopPropagation();
    };

    const handleClose = useCallback((e) => {
        if (e.target.nodeName !== 'INPUT')//dont hide on darkmode-switch - TODO - y?
            setAnchorEl(null);
        e.stopPropagation();
    }, [setAnchorEl]);

    const image = settings?.logo ? getImage(settings.logo.localFile) : null;

    const theme = useTheme();
    const colorMode = useContext(ColorModeContext);
    return (
        <>{translatedTopbarEntites.length > 0 && <>
            <IconButton
                edge="end"
                color="inherit"
                aria-label="menu"
                onClick={handleMenu}
                size="large">
                <MenuIcon />
            </IconButton>

            <SlideRoot>
                <Slide direction="down" in={open} mountOnEnter unmountOnExit>
                    <div className={classes.SlideRoot} onClick={handleClose} >
                        <div style={{ display: 'flex' }}>
                            <IconButton
                                edge="end"
                                className={classes.closeButton}
                                color="inherit"
                                aria-label="menu"
                                size="large">
                                <CloseIcon />
                            </IconButton>
                        </div>

                        <div className={classes.menu} onClick={handleClose}>

                            {image !== null ?
                                <div className={classes.item}><GatsbyImage className={classes.logo} image={image} alt="logo" layout="fullWidth" /></div> : <></>}

                            {translatedTopbarEntites?.map(e =>
                                <Link key={e.identifier} className={classes.item} onClick={handleClose} to={getEntityUrl({ entity: e, defaultLocale })}>
                                    {e.title}
                                </Link>
                            )}

                            <LanguageMenu {...{ classes, locales, curLocale, defaultLocale, handleClose, entity }} />

                            <div key="colorMode">
                                {settings?.menu?.themeSwitch === true && <div>
                                    <DarkmodeSwitch
                                        sx={{
                                            marginTop: '11px',
                                        }}
                                        onChange={colorMode.toggleColorMode}
                                        checked={theme.palette.mode === 'dark'}
                                    />
                                </div>}

                            </div>
                        </div></div>
                </Slide>
            </SlideRoot>
        </>}</>
    );
}

export default MainMenu;

const staticQuery = graphql`
    query {
        allStrapiEntities {
            nodes {
                identifier
                title
                locale
            }
        }
    }
`;

const PREFIX = 'MainMenu';

const classes = {
    SlideRoot: `${PREFIX}-SlideRoot`,
    menu: `${PREFIX}-menu`,
    item: `${PREFIX}-item`,
    logo: `${PREFIX}-logo`,
    closeButton: `${PREFIX}-closeButton`
};

// TODO jss-to-styled codemod: The Fragment SlideRoot was replaced by div. Change the tag if needed.
const SlideRoot = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.SlideRoot}`]: {
        backgroundColor: '#FFF',
        position: 'fixed',
        zIndex: 100,
        height: '100%',
        width: '100%',
        color: '#000',
        top: '0px',
        left: '0px'
    },

    [`& .${classes.menu}`]: {
        width: '94%',
        background: '#FFF',
        height: 'auto',
        position: 'fixed',
        right: '0',
        top: '49px',
        zIndex: '8000',
        margin: '0px 10px',
        overflow: 'auto',
        maxHeight: '90vh',
    },

    [`& .${classes.item}`]: {
        fontSize: '1.3em',
        fontWeight: 400,
        borderBottom: '1px solid',
        borderColor: '#DDD',
        paddingTop: 11,
        paddingBottom: 11,
        display: 'block',
        paddingLeft: 0,
        color: '#222',
        textDecoration: 'none',
        zIndex: 65535,
    },

    [`& .${classes.logo}`]: {

    },

    [`& .${classes.closeButton}`]: {
        flex: '0 1 auto',
        marginLeft: 'auto'

    }
}));
